import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Box from 'shopper/components/Box';
import Heading from 'shopper/components/Heading';
import Icon from 'shopper/components/Icon';
import Link from 'shopper/components/Link';
import Text from 'shopper/components/Text';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import Badge from './Badge';

import LINKS from 'constants/links';

const BadgesShowcase = ({ badges, className, gaEventCategory, ...rest }) => (
  <Box
    className={twMerge(
      'relative mt-3 items-start justify-start px-4 py-3 md:mt-6 md:flex-row md:items-center md:px-10 md:py-4',
      className
    )}
    full
    {...rest}
  >
    <div className="flex flex-col items-start">
      <div className="flex items-center">
        <Heading as="h2" size="size5">
          {placeholder('titles.earnedBadges')}
        </Heading>
        <Link
          className="ml-6"
          href={LINKS.BADGES_AND_LEVELS}
          size="size2"
          bold
          onClick={() => {
            sendEvent({
              category: gaEventCategory,
              action: 'know_more_badges',
            });
          }}
        >
          {placeholder('actions.seeMore')}
          <Icon className="ml-2" name="arrow-forward" />
        </Link>
      </div>
      <Text className="mt-2 md:w-[330px] md:min-w-[330px]" size="size2">
        {placeholder('descriptions.whatIsBadges')}
      </Text>
    </div>
    {/* TODO: make a way to tooltip overlap the overflow styles when mobile */}
    <div className="mt-3 flex w-full gap-x-6 overflow-y-hidden overflow-x-scroll py-2 md:ml-10 md:mt-0 md:py-4 xl:justify-between xl:gap-x-0 xl:overflow-x-visible xl:overflow-y-visible">
      {badges.map((badge) => (
        <Badge key={badge.badgeId} {...badge} />
      ))}
    </div>
  </Box>
);

BadgesShowcase.propTypes = {
  badges: PropTypes.arrayOf(
    PropTypes.shape({
      badgeId: PropTypes.number.isRequired,
      badgeImage: PropTypes.string.isRequired,
      badgeName: PropTypes.string.isRequired,
    })
  ).isRequired,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  gaEventCategory: PropTypes.string.isRequired,
};

export default BadgesShowcase;
